<style scoped>
.row-line {
  height: 40px;
}

.td-label {
  width: 100px;
  margin-right: 10px;
}
</style>

<template>
  <div>
    <Content :style="{background: '#fff',padding:'15px',margin:'10px'}">
      <div v-if="appList.length > 0">
        <Tabs v-model="currentId" @on-click="tabClick" type="card">
          <TabPane
            v-for="app in appList"
            :label="app.appname+'-'+app.platform"
            :key="app.id"
            :name="app.id"
          ></TabPane>
        </Tabs>
        <div>
          <Button @click="showAddDistModal">发布版本</Button>
        </div>
      </div>
      <div v-else-if="displayNoApps&&appList.length==0">
        <h1 style="text-align:center;font-size:30px;margin:50px">暂时无法发布版本，请先在应用管理中添加应用</h1>
      </div>
      <Table
        @on-row-click="ipaTableRowSelect"
        v-show="getPlatform() == 'ios'"
        stripe
        :columns="ipa_tdata.col_data"
        :data="ipa_tdata.current_data"
        :loading="ipa_tdata.loading"
        style="margin-top:10px"
      ></Table>
    </Content>
    <Modal
      v-model="ipaModal.modal"
      title="ipa归档"
      :mask-closable="false"
      @on-visible-change="onIPAModalVisible"
    >
      <div style="padding:10px">
        <table style="width:100%;">
          <tr class="row-line">
            <td class="td-label">ipa上传</td>
            <td>
              <Upload
                :format="['ipa']"
                style="float:left"
                :action="fileUpload.uploadurl"
                :data="fileUpload.fileUploadParams"
                :headers="fileUpload.headers"
                :show-upload-list="true"
                :on-success="onIpaFileUploadSuccess"
              >
                <Button icon="ios-cloud-upload-outline" :disabled="fileUpload.hasUpload">选择文件</Button>
              </Upload>
              <Icon
                type="md-checkmark"
                size="20"
                style="height:39px;line-height:39px;margin-left:10px"
                color="red"
                v-show="fileUpload.hasUpload"
              />
            </td>
          </tr>
          <!-- <tr class="row-line">
          <td class="td-label">ipa URL</td>
          <td>
            <Input v-model="ipaModal.submitModel.fileurl"/>
          </td>
          </tr>-->
          <tr class="row-line">
            <td class="td-label">发布类型</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.disttype">
                <Radio :label="1">正式发布</Radio>
                <Radio :label="0">测试发布</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">发布渠道</td>
            <td>
              <!-- <RadioGroup v-model="ipaModal.submitModel.distchannel">
                <Radio v-for="item in dict.distChannelItems" :key="item.id" :label="item.itemvalue">
                  <span>{{item.itemtext}}</span>
                </Radio>
              </RadioGroup> -->
              <iradiogroup dictcode="app_dist_channel" v-model="ipaModal.submitModel.distchannel"></iradiogroup>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.distchannel == 'enterprise'">
            <td class="td-label">描述文件过期时间</td>
            <td>
              <DatePicker
                type="date"
                v-model="ipaModal.submitModel.expiredate"
                style="width:100%"
                :clearable="false"
                :editable="false"
              ></DatePicker>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">应用版本</td>
            <td>
              <Input v-model="ipaModal.submitModel.appversion"/>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">Xcode版本</td>
            <td>
              <Input v-model="ipaModal.submitModel.xcodeversion"/>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">自测情况</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.selftest">
                <Radio :label="1">已自测</Radio>
                <Radio :label="0">未自测</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.selftest == 1">
            <td class="td-label">自测设备</td>
            <td>
              <Input v-model="ipaModal.submitModel.testdevice"/>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">消息推送</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.hasmsgpush">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.hasmsgpush == 1">
            <td class="td-label">推送证书上传</td>
            <td>
              <Upload
                :format="['ipa']"
                style="float:left"
                :action="fileUpload.uploadurl"
                :data="fileUpload.fileUploadParams"
                :headers="fileUpload.headers"
                :show-upload-list="false"
              >
                <Button icon="ios-cloud-upload-outline">选择文件</Button>
              </Upload>
            </td>
          </tr>
          <tr class="row-line" v-show="ipaModal.submitModel.hasmsgpush == 1">
            <td class="td-label">推送证书过期时间</td>
            <td>
              <DatePicker
                type="date"
                v-model="ipaModal.submitModel.pushcerexpiredate"
                style="width:100%"
                :clearable="false"
                :editable="false"
              ></DatePicker>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">来电显示</td>
            <td>
              <RadioGroup v-model="ipaModal.submitModel.hascid">
                <Radio :label="1">是</Radio>
                <Radio :label="0">否</Radio>
              </RadioGroup>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">开发者</td>
            <td>
              <Input v-model="ipaModal.submitModel.developername"></Input>
            </td>
          </tr>
          <tr class="row-line">
            <td class="td-label">更新说明</td>
            <td>
              <Input v-model="ipaModal.submitModel.updateinfo" type="textarea" :rows="4"></Input>
            </td>
          </tr>
        </table>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" @click="addIpaSubmit">确定</Button>
      </div>
    </Modal>
    <Modal v-model="apkModal.modal" title="apk归档">

    </Modal>
    <Modal v-model="h5Modal.modal" title="h5提交归档"></Modal>
  </div>
</template>

<script>
import iradiogroup from "../../components/iradiogroup";
export default {
  components:{iradiogroup},
  data() {
    return {
      ipa_tdata: {
        //是否显示loading框
        loading: false,
        //当前表格数据
        current_data: [],
        //表头数据
        col_data: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            type: "index",
            width: 60,
            align: "center"
          },
          {
            title: "应用版本号",
            key: "appversion"
          },
          {
            title: "Xcode版本号",
            key: "xcodeversion"
          },
          {
            title: "发布渠道",
            key: "distchannel"
          },
          {
            title: "过期日期",
            key: "expiredate"
          },
          {
            title: "开发者",
            key: "developername"
          },
          {
            title: "创建日期",
            key: "createtime"
          }
        ]
      },
      fileUpload: {
        hasUpload: false,
        fileUploadParams: {
          clientguid: this.$route.params.projectguid,
          userguid: localStorage.userguid
        },
        headers: {
          Authorization: localStorage.token
        },
        uploadurl: this.$axios.defaults.baseURL + "/mqms/file/upload"
      },
      currentId: "",
      displayNoApps: false,
      projectguid: this.$route.params.projectguid,
      appList: [],
      dict: {},
      ipaModal: {
        modal: false,
        submitModel: {
          expiredate: new Date()
        }
      },
      apkModal: {
        modal: false,
        submitModel: {}
      },
      h5Modal: {
        modal: false,
        submitModel: {}
      }
    };
  },
  methods: {
    ipaTableRowSelect(row){
      window.open("#/ipadistdetail/"+row.id);
    },
    tabClick(id) {
      if (this.getPlatform() == "ios") {
        this.getIpaDistList();
      }
    },
    onIPAModalVisible() {
      this.fileUpload.hasUpload = false;
      this.ipaModal.submitModel = {};
    },
    onIpaFileUploadSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.fileUpload.hasUpload = true;
        this.ipaModal.submitModel.filetag = response.data.id;
      } else {
        this.$Message.warning({
          title: "提示",
          content: response.msg
        });
      }
    },
    addIpaSubmit() {
      let _this = this;
      this.ipaModal.submitModel.approwid = this.currentId;
      this.$http.post({
        method: "mqms/iosdist/add",
        params: this.ipaModal.submitModel,
        success: function(data) {
          _this.ipaModal.modal = false;
          _this.getIpaDistList();
        },
        failure(code, msg) {
          _this.$Message.warning({
            title: "提示",
            content: msg
          });
        }
      });
    },
    getPlatform() {
      let platform = "";
      for (let i = 0; i < this.appList.length; i++) {
        if (this.appList[i].id == this.currentId) {
          platform = this.appList[i].platform;
        }
      }
      return platform;
    },
    showAddDistModal() {
      let platform = this.getPlatform();
      for (let i = 0; i < this.appList.length; i++) {
        if (this.appList[i].id == this.currentId) {
          platform = this.appList[i].platform;
        }
      }
      if (platform == "android") {
        this.apkModal.modal = true;
      } else if (platform == "ios") {
        this.ipaModal.modal = true;
      } else {
        this.h5Modal.modal = true;
      }
    },
    getAppList() {
      let _this = this;
      this.$http.get({
        method: "mqms/app/list",
        params: {
          projectguid: this.projectguid
        },
        success: function(data) {
          _this.appList = data;
          if (_this.appList.length > 0) {
            _this.currentId = data[0].id;
            if (data[0].platform == "ios") {
              _this.getIpaDistList();
            }
          }
          _this.displayNoApps = true;
        },
        failure(code, msg) {}
      });
    },
    init() {
      //获取平台类型
      let _this = this;
      this.$http.get({
        method: "base/dictitem/listbydictcode",
        params: {
          dictcode: "dist_archive_type"
        },
        success: function(data) {
          _this.dict.distArchiveTypeItems = data;
        },
        failure(code, msg) {}
      });
      this.$http.get({
        method: "base/dictitem/listbydictcode",
        params: {
          dictcode: "app_dist_channel"
        },
        success: function(data) {
          _this.dict.distChannelItems = data;
        },
        failure(code, msg) {}
      });
    },
    getIpaDistList() {
      let _this = this;
      this.$http.get({
        method: "mqms/iosdist/list",
        params: {
          approwid: this.currentId
        },
        success: function(data) {
          _this.ipa_tdata.current_data = data;
        },
        failure(code, msg) {}
      });
    }
  },
  mounted() {
    // this.init();
    this.getAppList();
  }
};
</script>